module.exports = __webpack_public_path__ + "img/pic-slider-4.00124d5.webp";